<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>提案・依頼一覧</h1>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex button-area">
      <!-- 検索ボタン-->
      <button pButton type="button" label="検索" class="button-size button1" (click)="getResultTaskDataList(true)"></button>
      <div class="button-margin"></div>
      <!-- 条件クリアボタン -->
      <button pButton type="button" label="検索条件をクリアする" class="button-size button2" (click)="clearConditions()"></button>
    </div>

    <!-- 検索条件入力 -->
    <div class="search-form-area" [formGroup]="c502SearchForm">
      <div class="p-d-flex p-jc-between item-div">
        <!-- 検索テキスト -->
        <!-- ステータス -->
        <div class="item">
          <label class="item-span">ステータス</label>
          <p-dropdown [options]="statusList" optionLabel="sp_name" optionValue="sp_code" placeholder="全て"
            [showClear]="true" styleClass="information-Form-dropdown" formControlName="status"></p-dropdown>
        </div>

        <!-- 期間 -->
        <div class="item">
          <label class="item-span">期間</label>
          <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
            placeholder="" dateFormat="yy/mm/dd" dataType="string" appendTo="body" yearRange="2000:2999"
            formControlName="date1" translate></p-calendar>
        </div>
        <div class="verticalTilde">〜</div>
        <div class="item">
          <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
            placeholder="" dateFormat="yy/mm/dd" dataType="string" appendTo="body" yearRange="2000:2999"
            formControlName="date2" translate></p-calendar>
        </div>
      </div>
    </div>

    <!-- 結果表示 -->
    <div class="result-area">
      <!-- ページアンカー -->
      <a id="jump-top"></a>
      <!-- 検索結果数 -->
      <div class="result-count-area">
        <label class="count"> {{ resultTaskDataList.length }} </label>
        件
      </div>
      <!-- リスト表示 -->
      <p-table #table [value]="resultTaskDataList" [paginator]="true" [rows]="50" [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)" [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません" selectionMode="single" styleClass="information-Form list-area" (onPage)="jumpTop()">
        <ng-template pTemplate="header">
          <tr>
            <th class="partner" pSortableColumn="partner">
              相手方 <p-sortIcon field="partner"></p-sortIcon>
            </th>
            <th class="situation" pSortableColumn="situation">
              状況 <p-sortIcon field="situation"></p-sortIcon>
            </th>
            <th class="title" pSortableColumn="title">
              提案・依頼タイトル <p-sortIcon field="title"></p-sortIcon>
            </th>
            <th pSortableColumn="agenda_id_title">
              課題・ソリューション <p-sortIcon field="agenda_id_title"></p-sortIcon>
            </th>
            <th class="status_name" pSortableColumn="status.name">
              ステータス <p-sortIcon field="status.name"></p-sortIcon>
            </th>
            <th class="update_datetime" pSortableColumn="update_datetime">
              更新日時 <p-sortIcon field="update_datetime"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-resultTaskDataList>
          <!-- fpt added: gray out the deleted issue -->
          <tr [ngClass]="resultTaskDataList.agenda_solution_delete_datetime?'issue-deleted':''">
            <!-- 相手方 -->
            <td><a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.partner }}</a></td>
            <!-- 状況 -->
            <td><a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.situation }}</a></td>
            <!-- 提案・依頼タイトル -->
            <td><a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.title }}</a></td>
            <!-- 課題・ソリューション -->
            <td><a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.agenda_id_title }}</a></td>
            <!-- ステータス -->
            <td [class.unanswered]="0 == resultTaskDataList?.status.id">
              <a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.status.name }}</a></td>
            <!-- 更新日 -->
            <td><a [attr.href]="'pages/platform/c601/' + resultTaskDataList.suggest_id" target="_blank">{{ resultTaskDataList?.update_datetime }}</a></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
